import { buildRoomWebSocketUrl } from "@infrastructure/websocket/roomWebSocketUrl";
import { ConnectionDiagnosticsSnapshot, WebSocketConnection } from "@infrastructure/websocket/WebSocketConnection";

export class ModeratorWebsocketController {
	private readonly connection: WebSocketConnection;

	constructor(roomName: string) {
		this.connection = new WebSocketConnection({ url: buildRoomWebSocketUrl(roomName) });
	}

	send(message: string): void {
		this.connection.send(message);
	}

	close(): void {
		this.connection.destroy();
	}

	getDiagnosticsSnapshot(): ConnectionDiagnosticsSnapshot {
		return this.connection.getDiagnosticsSnapshot();
	}
}
